// @ts-strict-ignore
import {createContext, useContext} from 'react';

import {Directions} from 'common/components/drop-menu/types';

export type QueryBuilderContextValue = {
  isCoreReportQb?: boolean;
  qbAlignment?: Directions;
};

export const QueryBuilderContext = createContext<QueryBuilderContextValue>(null);
export const QueryBuilderContextConsumer = QueryBuilderContext.Consumer;
export const QueryBuilderContextProvider = QueryBuilderContext.Provider;
export const useQueryBuilderContext = () => useContext(QueryBuilderContext);
